module.exports = __webpack_public_path__ + "static/media/subnav-nodejs.47fb89a6.svg";